// extracted by mini-css-extract-plugin
export default {"h1":"VendorSale_h1__k92AQ","scrollCover":"VendorSale_scrollCover__NFSOG","liquid":"VendorSale_liquid__F96HI","saleListCont":"VendorSale_saleListCont__ShBM-"};